export const stringifyData = (data, title: any) => {
  const dataToBeStringified = JSON.stringify(data);
  localStorage.setItem(`${title}`, dataToBeStringified);
};

export const getStringifiedData = (name: any) => {
  let data = localStorage.getItem(`${name}`);
  return JSON.parse(data);
};
